import { createRoute, lazyRouteComponent, Navigate } from "@tanstack/react-router";

import { appLayoutRoute } from "../../router/rootRoutes";
import { myListsSearchSchema } from "./routeSearch";

const myListsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/my-lists",
  validateSearch: myListsSearchSchema,
  component: lazyRouteComponent(() => import("./MyListsPage"), "MyListsPage"),
});

/**
 * Where this surface used to live.
 *
 * Kept because the old path was in the navigation of every installed copy of
 * the app, and a bookmark or a back-stack entry pointing at it should land on
 * the library rather than the not-found state.
 */
const legacyListsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/lists",
  component: () => <Navigate replace to="/my-lists" search={{}} />,
});

export const libraryRoutes = [myListsRoute, legacyListsRoute] as const;
